import ImportRateCardMenuButton, { ImportRateScope } from '../Utils/ImportRateCardMenuButton';

export default function ConsumableImportRateCardMenuButton({
  onSelect,
}: {
  onSelect: (scope: ImportRateScope) => void;
}) {
  return <ImportRateCardMenuButton onSelect={onSelect} idPrefix="import-rate-card" />;
}
